module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Application notices"},"et":{"title":"Application notices"},"ru":{"title":"Application notices"}}')
  delete Component.options._Ctor
}
